import React from 'react';
import { trackError } from '@/utils/analytics';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    trackError(
      'react_crash',
      error?.message || 'Unknown React error',
      (error?.stack || '') + '\n\nComponent Stack: ' + (errorInfo?.componentStack || '')
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: 'flex', flexDirection: 'column', alignItems: 'center', 
          justifyContent: 'center', minHeight: '100vh', padding: '2rem',
          fontFamily: 'system-ui, sans-serif', background: '#f8fafc', textAlign: 'center'
        }}>
          <div style={{ 
            background: 'white', borderRadius: '16px', padding: '3rem', 
            maxWidth: '450px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{margin: '0 auto'}}>
                <circle cx="12" cy="12" r="10"/>
                <path d="M16 16s-1.5-2-4-2-4 2-4 2"/>
                <line x1="9" y1="9" x2="9.01" y2="9"/>
                <line x1="15" y1="9" x2="15.01" y2="9"/>
              </svg>
            </div>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: '#1e293b', marginBottom: '8px' }} dir="auto">
              Oops! Något gick fel
            </h2>
            <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '0.95rem', lineHeight: '1.6' }} dir="auto">
              حدث خطأ غير متوقع. يرجى إعادة تحميل الصفحة.
              <br/>
              Ett oväntat fel uppstod. Ladda om sidan.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              style={{
                background: '#3b82f6', color: 'white', border: 'none',
                padding: '12px 32px', borderRadius: '10px', fontSize: '1rem',
                fontWeight: '600', cursor: 'pointer', width: '100%'
              }}
              data-testid="error-boundary-reload"
            >
              Ladda om / إعادة التحميل
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
